module.exports = __webpack_public_path__ + "static/media/mauna.b1edb2e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/mauna.png
// module id = 280
// module chunks = 0